import { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export const OfflineIndicator = () => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const [showIndicator, setShowIndicator] = useState(false);

	useEffect(() => {
		const handleOnline = () => {
			setIsOnline(true);
			setShowIndicator(true);
			setTimeout(() => setShowIndicator(false), 3000);
		};

		const handleOffline = () => {
			setIsOnline(false);
			setShowIndicator(true);
		};

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	if (!showIndicator) return null;

	return (
		<div
			className={cn(
				'fixed bottom-4 right-4 z-50 flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg transition-all duration-300',
				'bg-background border border-border',
				isOnline ? 'text-success' : 'text-destructive'
			)}
		>
			{isOnline ? (
				<>
					<Wifi className="h-4 w-4" />
					<span className="text-sm font-medium">Back online</span>
				</>
			) : (
				<>
					<WifiOff className="h-4 w-4" />
					<span className="text-sm font-medium">Offline mode</span>
				</>
			)}
		</div>
	);
};
